/* eslint-disable react/prop-types */

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";

const LeftCaret = () => <FontAwesomeIcon icon={faAngleLeft} />;

export default LeftCaret;
